import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { Button } from '../../components/ui/Button';
import { InputField } from '../../components/ui/InputField';
import { api, ApiError } from '../../lib/api';

const steps = [
  'Проверьте почту и откройте письмо',
  'Создайте новый пароль',
  'Подтвердите вход на устройстве',
];

export function ResetPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.passwordResetRequest(email);
      setSent(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось отправить ссылку.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout>
      <div className="mx-auto flex w-[420px] max-w-full flex-col gap-6">
        <Link to="/login" className="text-xs font-medium text-action-primary">
          ← Вернуться ко входу
        </Link>

        <div>
          <div className="flex size-12 items-center justify-center rounded-[14px] bg-ai-accent text-lg text-text-inverse">
            ↻
          </div>
          <h1 className="mt-4 text-[28px] font-semibold text-text-primary">Восстановление доступа</h1>
          <p className="mt-2 text-[13px] leading-relaxed text-text-secondary">
            Укажите рабочую почту. Мы отправим ссылку
            <br />
            для создания нового пароля.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
          <InputField
            label="Рабочая почта"
            type="email"
            placeholder="name@company.ru"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={sent}
            required
          />

          {error && <p className="text-xs font-medium text-status-warning">{error}</p>}

          <Button type="submit" className="w-full" disabled={sent || submitting}>
            {sent ? 'Ссылка отправлена' : submitting ? 'Отправляем…' : 'Отправить ссылку'}
          </Button>
        </form>

        <div className="rounded-xl bg-bg-surface-secondary p-4">
          <p className="text-xs font-semibold text-text-primary">Что произойдёт дальше</p>
          <ol className="mt-3 flex flex-col gap-2">
            {steps.map((step, index) => (
              <li key={step} className="text-[11px] text-text-secondary">
                {index + 1}. {step}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </AuthLayout>
  );
}
